<template>
  <div class="history-curve">
    <div class="cure-top">
      <div class="two-font-wrapper" @click="back">
          <div class="icon-font">&#xe612;</div>
          返回
        </div>
      <div class="cure-top-title">水分传感器历史曲线</div>
      <div class="cure-top-select">
        <div style="margin-right: 1vw">
          <DropDownInput type="0" :items="sensorValue" :content="historyInfo.nodeId" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
        </div>
        <div style="display: flex">
          <div class="input-contain">
            <div class="input-title">X：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input  v-model="historyInfo.siteX"/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">Y：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input v-model="historyInfo.siteY"/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">Z：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input v-model="historyInfo.siteZ"/>
            </div>
          </div>
        </div>
        <div class="input-date-wrapper">
          <el-date-picker
            v-model="value"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="query button" @click="buttonSearch">查询</div>
      </div>
    </div>
    <div v-if="historyInfo.nodeId" class="history-info">设备ID：{{historyInfo.nodeId}}<span v-if="stack">，采集位置：{{stack}}{{maintainStage}}</span></div>
    <div class="loading-data" v-if="loading">
      <i class="el-icon-loading"></i>
      <div>加载中，请稍后···</div>
    </div>
    <div class="chart-wrapper" v-show="!loading" id="myChart8" v-if="rows.length > 0"></div>
    <div class="none-data" v-if="!loading && rows.length<1">暂无数据</div>
  </div>
</template>

<script>
import DropDownInput from '../../../../components/DropDownInput.vue'
import {queryRtNodeMonitInfo, queryNodeAvgHistoryInfo, queryMaintainPlanBySite} from '../../../../api/maintain'
import {getDay, renderTime} from '../../../../tools/methods'
let echarts = require('echarts')
let myChart8
export default {
  name: 'HistoryWater',
  components: { DropDownInput },
  data () {
    return {
      percentage: '',
      rows: [],
      loading: false,
      moduleType: '01',
      nodeType: '05',
      sensorValue: [],
      siteLocation: '',
      value: '',
      historyInfo: {
        endTime: '',
        nodeId: '',
        siteX: '',
        siteY: '',
        siteZ: '',
        startTime: ''
      },
      name_P: '水分/(%)',
      maintainStage: '',
      stack: ''
    }
  },
  watch: {
    value: function () {
      console.log(this.value)
      this.historyInfo.startTime = this.value !== null ? this.value[0] : ''
      this.historyInfo.endTime = this.value !== null ? this.value[1] : ''
    }
  },
  created () {
    this.handleSearch()
    if (this.$route.query.nodeId) {
      this.stack = this.$route.query.stack
      this.historyInfo.startTime = getDay(-6)
      this.historyInfo.endTime = getDay(0)
      this.historyInfo.nodeId = this.$route.query.nodeId
      this.value = [getDay(-6), getDay(0)]
      console.log(this.historyInfo)
      this.buttonSearch()
     this.maintainStage=this.$route.query.maintainStage
    }
  },
  methods: {
    buttonSearch: function () {
      this.loading = true
      queryNodeAvgHistoryInfo(this.historyInfo).then(res => {
        if (res.code === 500) {
          this.loading = false
          this.$message({
            message: res.message,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        } else {
          res.data.map(item => {
            item.createdTime = renderTime(item.createdTime)
          })
          console.log(res)
          this.rows = res.data
          this.loading = false
          let that = this
          if (this.rows.length > 0) {
            setTimeout(function () {
              that.getCharts()
              myChart8.on('legendselectchanged', function (obj) {
                console.log(obj)
                if (obj.selected.水分高 === false && obj.selected.水分低 === false && obj.selected.水分均 === false) {
                  that.name_P = ''
                  that.getChart8()
                }
                if (obj.selected.水分高 === true || obj.selected.水分低 === true || obj.selected.水分均 === true) {
                  that.name_P = '水分/(%)'
                  that.getChart8()
                }
              })
            }, 100)
          }
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    sendValue: function (value) {
      console.log(value)
      this.handleSearch(value)
    },
    showInfo: function (data) {
      this.historyInfo.nodeId = data.nodeId
      console.log(data)
    },
    handleSearch: function (value) {
      let body = {
        moduleType: this.moduleType,
        nodeType: this.nodeType,
        nodeId: value
      }
      queryRtNodeMonitInfo(body).then(res => {
        console.log(res)
        this.sensorValue = res.data.rows
      }).catch(err => {
        console.log(err)
      })
    },
    getCharts: function () {
      this.getChart8(0)
      window.onresize = function () {
        myChart8.resize()
      }
    },
    getChart8: function () {
      console.log(this.rows)
      let date = []
      let maxValue = []
      let minValue = []
      let avgValue = []
      if (this.rows.length < 25) {
        this.percentage = 100
      } else {
        this.percentage = 2500 / this.rows.length
      }
      this.rows.map(item => {
        date.push(item.date_time)
        maxValue.push(item.max_val)
        minValue.push(item.min_val)
        avgValue.push(item.avg_val)
      })
      myChart8 = echarts.init(document.getElementById('myChart8'))
      myChart8.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {type: 'dashed'}
          }
        },
        textStyle: {color: '#ffffff'},
        legend: {
          x: 'right',
          y: 'top',
          itemGap: 50,
          textStyle: {color: '#01c5f1'},
          data: [
            {name: '水分低'},
            {name: '水分高'},
            {name: '水分均'}
          ]
        },
        grid: {
          top: '15%',
          right: '0',
          left: '0.5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: {show: false},
          axisTick: false,
          axisLine: {
            lineStyle: {color: '#32b16c'}
          },
          axisLabel: {
            textStyle: {
              fontSize: 8
            },
            interval: 0,
            rotate: 45
          },
          data: date
        },
        yAxis: {
          type: 'value',
          scale: 'true',
          axisTick: false,
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: ['#2a2f57']
            }
          },
          axisLine: {
            lineStyle: {color: '#32b16c'}
          },
          splitNumber: '5',
          name: this.name_P
        },
        dataZoom: [
          {
            type: 'slider',
            show: false,
            start: 1,
            end: this.percentage,
            handleSize: 8
          },
          {
            type: 'inside',
            start: 1,
            end: this.percentage
          },
          {
            type: 'slider',
            show: false,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 12,
            height: '70%',
            handleSize: 8,
            showDataShadow: false,
            left: '93%'
          }
        ],
        series: [
          {
            name: '水分低',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#01c5f1'
                },
                color: '#01c5f1'
              }
            },
            data: minValue
          },
          {
            name: '水分高',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#a84200'
                },
                color: '#a84200'
              }
            },
            data: maxValue
          },
          {
            name: '水分均',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#32b16c'
                },
                color: '#32b16c'
              }
            },
            data: avgValue
          }
        ]
      })
    },
    back: function () {
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped>
  @import "HistoryCurve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/core/historyCurve/HistoryWater.vue